
import React from "react";
import Datenschutz from "@/components/Datenschutz";
import { Helmet } from "react-helmet";

const DatenschutzPage = () => {
  return (
    <div className="min-h-screen bg-joerg-50">
      <Helmet>
        <title>Datenschutzerklärung | Jörg Hörmann Coaching & Consulting</title>
        <meta name="description" content="Informationen zum Datenschutz bei Jörg Hörmann Coaching & Consulting. Erfahren Sie, wie wir mit Ihren Daten umgehen und welche Rechte Sie haben." />
        <meta name="robots" content="noindex, follow" />
      </Helmet>
      <div className="pt-32">
        <Datenschutz />
      </div>
    </div>
  );
};

export default DatenschutzPage;
